<template>
  <div class="mt-2">
    <div class="mb-2">
        <v-btn icon :to="{ name: redirect, params: { ano, cdturma, disciplina, tipoDeEnsino, cdinstruc, AEEouACP, aulasParaLancarFrequencia, frequenciaLancada, pagina, turmaOuDisciplina } }">
          <v-icon>arrow_back</v-icon>
        </v-btn>
    </div>

    <v-alert
      type="error"
      :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0"
      dark
      class="mb-3"
    >
      <div v-if="$v.$invalid && $v.$dirty">
        Informe a frequência de todos os alunos.
      </div>
      <div v-if="msgArrayError.length > 0">
        <ul v-for="error of msgArrayError" :key="error.key">
          <li>{{ error }}</li>
        </ul>
      </div>
    </v-alert>

    <v-card class="pa-3">
      <div><strong>Período Avaliativo:</strong> {{ periodoAvaliativo }}</div>
      <div><strong>Data:</strong> {{ dataExibir }}</div>
      <div><strong>Código(s) Aula(s):</strong> {{ aula }}</div>
      <div><strong>Assunto Lecionado:</strong> {{ assuntoLecionado }}</div>
      <div v-if="descricaoDisciplinas">
        <strong>{{
          showCampoExperiencia() ? "Campos de Experiência:" : "Disciplina(s):"
        }}</strong>
        {{ descricaoDisciplinas }}
      </div>

    <div aria-live="polite" style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(1px, 1px, 1px, 1px);">
        {{ messagemAlertaFrequencia }}
    </div>

      <form @submit.prevent="onSubmit">
        <v-flex xs12>
          <table class="table-siged mt-3" ref="tabela">
            <thead style="vertical-align: top">
              <tr>
                <th style="width: 10%">Foto</th>
                <th style="width: 45%">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" size="20"
                        >notification_important</v-icon
                      >
                    </template>
                    <span class="text-caption white--text"
                      >Dê um duplo clique no nome do aluno abaixo para
                      visualizar <br />informações de contato sobre o respectivo
                      aluno.</span
                    >
                  </v-tooltip>
                  Aluno
                </th>
                <th style="width: 10%; height: 100%">Data Enturmação</th>
                <th style="width: 20%">
                  Frequência
                  <div style="margin-top: 5px">
                    <v-btn icon color="green" @click="marcarTodos"
                      ><v-icon>playlist_add_check</v-icon>
                    </v-btn>
                  </div>
                </th>
                <th v-if="exibirColunaRemoto" style="width: 20%">
                  <span>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" size="20"
                          >notification_important</v-icon
                        >
                      </template>
                      <span class="text-caption white--text"
                        >Esta coluna representa a forma como o aluno participou
                        da aula, <br />se participou de forma remota ou
                        presencial.</span
                      >
                    </v-tooltip>
                  </span>
                  <span> Presencial ou Remoto? </span>
                  <div>
                    <v-btn
                      icon
                      color="green"
                      :disabled="this.aulaRemota"
                      @click="marcarTodosRemoto"
                      ><v-icon>playlist_add_check</v-icon>
                    </v-btn>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="form.alunos.length === 0">
                <td colspan="4">Nenhum aluno encontrado!</td>
              </tr>
              <tr v-for="(key, index) in form.alunos" :key="key.id">
                <td class="centro">foto</td>
                <td
                  style="cursor: pointer"
                  @dblclick="
                    dadosContatoAluno = {
                      dialog: true,
                      cdtipesc: $store.getters.school.cdtipesc,
                      cdescola: $store.getters.school.cdescola,
                      numatalun: key.numatalun,
                    }
                  "
                >
                  {{ key.nomeAluno }}
                </td>
                <td>{{ key.dataEnturmacao | formatDataBR }}</td>
                <td class="centro">
                  <div
                    v-if="
                      verificarSituacao(key.situacao_fim, key.dataSituacaoFim)
                    "
                  >
                    <span>{{ key.situacao_fim.dssitalun }}</span>
                    <span v-if="key.dataSituacaoFim">
                      - {{ key.dataSituacaoFim | formatDataBR }}</span
                    >
                  </div>
                  <div v-else-if="verificarDataEnturmacao(key.dataEnturmacao)">
                    NÃO ESTAVA NA TURMA
                  </div>
                  <!-- Quando a data da enturmação for maior que a data da aula -->
                  <div v-else-if="key.dispensadoDisciplina">DISPENSADO</div>
                  <div v-else>
                    <CheckFrequencia
                      :disabled="verificarDataEnturmacao(key.dataEnturmacao)"
                      v-if="exibirColunaRemoto"
                      :atestado="key.indicaatestado"
                      v-model="form.alunos[index].indicapresenca"
                      @input="
                        if (form.alunos[index].indicapresenca === 'A')
                          form.alunos[index].indicaalunoremoto = '';
                        else form.alunos[index].indicaalunoremoto = 'S';
                      "
                    />
                    <CheckFrequencia
                      :disabled="verificarDataEnturmacao(key.dataEnturmacao)"
                      v-else
                      :atestado="key.indicaatestado"
                      v-model="form.alunos[index].indicapresenca"
                      @input="form.alunos[index].indicaalunoremoto = 'N'"
                    />
                  </div>
                </td>
                <td v-if="exibirColunaRemoto" class="centro">
                  <div
                    v-if="
                      verificarSituacao(key.situacao_fim, key.dataSituacaoFim)
                    "
                  ></div>
                  <div
                    v-else-if="verificarDataEnturmacao(key.dataEnturmacao)"
                  ></div>
                  <div v-else-if="key.dispensadoDisciplina"></div>
                  <div v-else>
                    <!-- (form.alunos[index].indicapresenca === 'A') ? 'N' : key.indicaalunoremoto -->
                    <!-- :remoto=" retornaRemotoInicial(form.alunos[index].indicapresenca)" -->
                    <CheckFrequencia
                      :disabled="
                        indicamodelodeaula === 'R' || aulaRemota
                          ? true
                          : verificarDataEnturmacao(key.dataEnturmacao) ||
                            form.alunos[index].indicapresenca === 'A' ||
                            form.alunos[index].indicapresenca === null
                      "
                      :remoto="
                        indicamodelodeaula === 'R' &&
                        form.alunos[index].indicapresenca === 'P'
                          ? 'S'
                          : form.alunos[index].indicapresenca === 'A'
                          ? ''
                          : key.indicaalunoremoto
                      "
                      v-model="form.alunos[index].indicaalunoremoto"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </v-flex>
        <div style="text-align: right" class="mt-2">
          <v-btn
            class="rounded-sm font-weight-regular"
            type="submit"
            :loading="loading"
            style="color: white"
            color="teal"
            :disabled="desabilitarBotao()"
            >Salvar</v-btn
          >
        </div>
      </form>
    </v-card>

    <v-snackbar
      v-model="snackbar"
      bottom
      left
      :timeout="4000"
      height="10px"
      rounded="0"
    >
      <div class="d-flex justify-space-between align-center">
        <span> {{ submitText }}</span>
        <v-btn class="text-right" v   nt="text" icon @click="snackbar = false">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <ContatoAluno v-bind.sync="dadosContatoAluno" />
    <template>
      <v-layout row justify-center>
         <v-dialog v-model="dialog" persistent max-width="600">
          <v-card>
            <v-card-title class="headline">Atenção</v-card-title>
            <v-card-text>Olá, identificamos que existem alterações nas frequências que devem ser salvas. Você confirma essas alterações ?</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div >
                <v-row class="d-flex flex-wrap justify-center pa-2">
                  <v-col class="pa-1 flex-grow-1 " >
                      <v-btn
                        class="rounded-sm font-weight-regular text-capitalize flex-grow-1"
                        color
                        @click="handleDescartarAlteracoes"
                      >Descartar alterações</v-btn>

                  </v-col>
                  <v-col class="pa-1"  >
                    <v-btn
                      class="rounded-sm font-weight-regular custom-transform-class text-none white--text"
                      color="teal"
                      :loading="loading"
                      :disabled="loading"
                      @click="handleSalvarAlteracoes"
                    >Ok, confirmo o lançamento das frequências</v-btn>

                  </v-col>

                </v-row>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
       </v-layout>
     </template>





  </div>
</template>

<script>
import store from "@/store/index";
import { required } from "vuelidate/lib/validators";
import CheckFrequencia from "@/components/CheckFrequencia";
import ContatoAluno from "@/components/ContatoAluno";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import FormatDataBR from "@/plugins/filters/formatDataBR";

const DiarioEscolarRepository = RepositoryFactory.get("diarioEscolar");

const dadosUser = () => ({
  ...store.getters.userProfessor,
  cdtipesc: store.getters.school.cdtipesc,
  cdescola: store.getters.school.cdescola,
});

export default {
  name: "FrequenciaAEEouACP",
  components: {
    CheckFrequencia,
    ContatoAluno,
  },
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    aulas: Array,
    tipoDeEnsino: [String],
    cdinstruc: [Number],
    redirect: {
      type: String,
      default: "diario-escolar-aulas",
    },
    aulasParaLancarFrequencia: [Array],
    frequenciaLancada: [Array],
    pagina: [Number],
    turmaOuDisciplina: [String],
    AEEouACP: [Boolean],
  },
  beforeRouteLeave: function (to, from, next) {
    if(!this.usuarioMudouFrequencia || this.descartarAlteracoes ){
      next();
      this.dialog = false
    }else {
      this.router_leave = to.name
      this.dialog = true

    }


  },
  created() {
    window.addEventListener("keydown", this.atalhoParaVoltar)
  },
  data() {
    const { cdtipesc, cdescola } = dadosUser();

    return {
      messagemAlertaFrequencia: "",
      retornarParaATelaInicial: false,
      router_leave: '',
      descartarAlteracoes: false,
      dialog: false,
      periodoAvaliativo: "",
      dataaula: "",
      dataExibir: "",
      aula: "",
      aulaRemota: "",
      assuntoLecionado: "",
      descricaoDisciplinas: "",
      loading: false,
      msgArrayError: [],
      submitText: "",
      snackbar: false,
      situacaoFim: [],
      form: {
        identificadoraula: [],
        cdtipesc,
        cdescola,
        alunos: [],
      },
      dadosContatoAluno: {},
      aulaLancadaFrequencia: this.frequenciaLancada,
      aulasLancandoFrequencia: this.aulasParaLancarFrequencia,
      indicamodelodeaula: "",
      exibirColunaRemoto: false,
      identificadoraulaAluno: [],
      frequenciasIniciais: [],
    };
  },

mounted() {
   document.addEventListener('keydown', this.onKeyDown);
  },

  async beforeRouteEnter(to, from, next) {
    if (typeof to.params.aulas === "undefined") {
      return next("/diario-escolar");
    }
    try {
      const aulasId =
        typeof to.params.aulas[0] === "object"
          ? to.params.aulas.map((key) => key.id)
          : to.params.aulas;

      const { data } = await DiarioEscolarRepository.getListarAulas({
        ...dadosUser(),
        aulas: aulasId,
        cdturma: to.params.cdturma,
        aaletivo: to.params.ano,
        AEEouACP: to.params.AEEouACP,
      });

      next((vm) =>
        vm.load(
          data.results.aulas,
          data.results.situacoesFim,
          aulasId,
          data.results.configuracaoAnoLetivo
        )
      );
    } catch (e) {
      return next("/diario-escolar");
    }
  },
  validations() {
    return {
      form: {
        identificadoraula: { required },
        cdtipesc: { required },
        cdescola: { required },
        alunos: {
          required,
          $each: {
            numatalun: { required },
            indicapresenca: {
              required: function (value, aluno) {
                return (
                  aluno.indicapresenca != null ||
                  (aluno.indicapresenca == null &&
                    (this.verificarDataEnturmacao(aluno.dataEnturmacao) ||
                      this.verificarSituacao(
                        aluno.situacao_fim,
                        aluno.dataSituacaoFim
                      ) ||
                      aluno.dispensadoDisciplina))
                );
              },
            },
          },
        },
      },
    };
  },
  methods: {
    onKeyDown(event) {                  
      if (event.altKey && (event.key === 'p' || event.key === 'P' )) {        
        this.messagemAlertaFrequencia = "Lançado presença para todos os alunos."
        this.marcarTodos();        
      }
      if (event.altKey && (event.key === 'a' || event.key === 'A')) {
        this.messagemAlertaFrequencia = "Lançado ausência para todos os alunos."
        this.desmarcarTodos()
      }
      if (event.altKey && (event.key === 'g' || event.key === 'G')) {
            this.messagemAlertaFrequencia = "Dados salvo com sucesso. Pressione Alt + V para voltar a tela Listagem de Aulas."
            this.handleSalvarAlteracoes()
      }      
    },

    async handleSalvarAlteracoes() {
      await this.onSubmit()
      this.descartarAlteracoes = false
      this.dialog = false
      this.retornarParaATelaInicial = !this.$v.$invalid

      this.frequenciasIniciais = [...this.frequenciasModificadas]
      if(this.retornarParaATelaInicial)
        this.$router.push(
                            {
                                name: this.router_leave,
                                params: {
                                  ano: this.ano,
                                  cdturma: this.cdturma,
                                  disciplina: this.disciplina,
                                  tipoDeEnsino: this.tipoDeEnsino,
                                  cdinstruc: this.cdinstruc,
                                  AEEouACP: this.AEEouACP,
                                  aulasParaLancarFrequencia: this.aulasParaLancarFrequencia,
                                  frequenciaLancada: this.frequenciaLancada,
                                  pagina: this.pagina,
                                  turmaOuDisciplina: this.turmaOuDisciplina,
                                },
                              }
                          )

      },
    handleDescartarAlteracoes() {
      this.descartarAlteracoes = true
      this.dialog = false
      this.$router.push(
                          {
                              name: this.router_leave,
                              params: {
                                ano: this.ano,
                                cdturma: this.cdturma,
                                disciplina: this.disciplina,
                                tipoDeEnsino: this.tipoDeEnsino,
                                cdinstruc: this.cdinstruc,
                                AEEouACP: this.AEEouACP,
                                aulasParaLancarFrequencia: this.aulasParaLancarFrequencia,
                                frequenciaLancada: this.frequenciaLancada,
                                pagina: this.pagina,
                                turmaOuDisciplina: this.turmaOuDisciplina,
                              },
                            }
                        )

    },
    atalhoParaVoltar(event) {
      if(event.altKey && event.key === 'v') {

        this.$router.push(
                          {
                              name: this.redirect,
                              params: {
                                ano: this.ano,
                                cdturma: this.cdturma,
                                disciplina: this.disciplina,
                                tipoDeEnsino: this.tipoDeEnsino,
                                cdinstruc: this.cdinstruc,
                                AEEouACP: this.AEEouACP,
                                aulasParaLancarFrequencia: this.aulasParaLancarFrequencia,
                                frequenciaLancada: this.frequenciaLancada,
                                pagina: this.pagina,
                                turmaOuDisciplina: this.turmaOuDisciplina,
                              },
                            }
                        )
        }




    },
    showCampoExperiencia() {
      return this.tipoDeEnsino === "I" && Number(this.ano) >= 2020;
    },
    load(aulasSelecionadas, situacoesFim, aulasId, configuracaoAnoLetivo) {
      this.situacaoFim = situacoesFim;
      this.periodoAvaliativo =
        aulasSelecionadas[0].periodo_avaliativo.dspravadi;
      this.dataaula = aulasSelecionadas.map((key) => key.dataaula).sort()[0];
      this.dataExibir = "";
      this.descricaoDisciplinas = "";
      this.indicamodelodeaula = configuracaoAnoLetivo.indicamodelodeaula;
      this.exibirColunaRemoto = this.indicamodelodeaula !== "P" ? true : false;

      const multiDisciplina = aulasSelecionadas.some(
        (key) => key.cddiscipl != this.disciplina
      );
      const listaDataExibir = new Set();
      const listaAssuntoLecionado = new Set();
      const listDescricaoDisciplinas = new Set();

      for (let key of aulasSelecionadas) {
        this.aula += `${key.identificadoraula}, `;
        this.assuntoLecionado += `${key.descricaoassuntolecionado}, `;
        listaAssuntoLecionado.add(key.descricaoassuntolecionado);
        this.aulaRemota = key.indicapresencial === "N" ? true : false;

        this.dataExibir += `${FormatDataBR(key.dataaula)}, `;
        listaDataExibir.add(FormatDataBR(key.dataaula));
        if (multiDisciplina) {
          this.descricaoDisciplinas += `${key.disciplina.dsdiscipl}, `;
          listDescricaoDisciplinas.add(key.disciplina.dsdiscipl);
        }
      }
      this.aula = this.aula.substring(0, this.aula.length - 2);
      this.assuntoLecionado = this.assuntoLecionado.substring(
        0,
        this.assuntoLecionado.length - 2
      );
      this.dataExibir = this.dataExibir.substring(
        0,
        this.dataExibir.length - 2
      );

      this.dataExibir =
        listaDataExibir.size == 1
          ? Array.from(listaDataExibir).sort().join("")
          : Array.from(listaDataExibir).sort().join(", ");

      this.assuntoLecionado =
        listaAssuntoLecionado.size == 1
          ? Array.from(listaAssuntoLecionado).join("")
          : Array.from(listaAssuntoLecionado).join("/ ");

      if (multiDisciplina) {
        this.descricaoDisciplinas = this.descricaoDisciplinas.substring(
          0,
          this.descricaoDisciplinas.length - 2
        );
        this.descricaoDisciplinas =
          listDescricaoDisciplinas.size == 1
            ? Array.from(listDescricaoDisciplinas).join("")
            : Array.from(listDescricaoDisciplinas).join("/ ");
      }

      this.form.identificadoraula = aulasId;

      let indexAula = 0;
      for (let index in aulasSelecionadas) {
        if (aulasSelecionadas[index].frequencias !== null) {
          indexAula = index;
        }

        let lista = aulasSelecionadas[
          indexAula
        ].aulaalunoatendimentoespecial.map((key) => {
          const indexFrequencia = aulasSelecionadas[
            indexAula
          ].frequencias.reduce((total, valor, index) => {
            if (total >= 0) {
              return total;
            }
            if (
              valor.cdtipesc == key.cdtipesc &&
              valor.cdescola == key.cdescola &&
              valor.numatalun == key.numatalun
            ) {
              return index;
            }
            return -1;
          }, -1);

          let indicapresenca = null;
          let indicaatestado = null;
          let indicaalunoremoto = null;
          if (indexFrequencia >= 0) {
            indicapresenca =
              aulasSelecionadas[indexAula].frequencias[indexFrequencia]
                .indicapresenca;
            indicaatestado =
              aulasSelecionadas[indexAula].frequencias[indexFrequencia]
                .indicaatestado;
            indicaalunoremoto =
              aulasSelecionadas[indexAula].frequencias[indexFrequencia]
                .indicaalunoremoto;
          }

          let dispensadoDisciplina = false;
          if (
            key.matricula.disciplinas_dispensadas != null &&
            key.matricula.disciplinas_dispensadas.length > 0
          ) {
            dispensadoDisciplina =
              key.matricula.disciplinas_dispensadas
                .map((valor) => valor.cddiscipl)
                .indexOf(this.disciplina) >= 0;
          }

          return {
            numatalun: key.numatalun,
            indicapresenca,
            indicaatestado,
            indicaalunoremoto,
            situacao_fim: {
              cdsitalun: key.matricula.cdsitalun,
              dssitalun: key.matricula.dssitalun,
            },
            dataSituacaoFim: key.matricula.dtafastam,
            nomeAluno: key.matricula.nmaluno,
            dataEnturmacao: key.matricula.dtsitalun,
            dispensadoDisciplina,
          };
        });

        for (let e of lista) {
          let existe =
            this.form.alunos.filter((object) => object.numatalun == e.numatalun)
              .length > 0;
          if (!existe) this.form.alunos = this.form.alunos.concat(e);
        }
        // this.frequenciasIniciais = this.form.alunos.map (f => f.indicapresenca)
      }
      this.frequenciasIniciais = this.form.alunos.map (f => f.indicapresenca)
      this.$Progress.finish();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (window.scrollY >= 250) {
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
        return;
      }
      if (this.aulaRemota) {
        this.form.alunos.forEach((element) => {
          if (this.aulaRemota && element.indicapresenca === "P") {
            element.indicaalunoremoto = "S";
          } else if (this.aulaRemota && element.indicapresenca === "A") {
            element.indicaalunoremoto = "";
          }
        });
      }

      try {
        this.loading = true;
        const formulario = {
          ...this.form,
          alunos: this.form.alunos.filter((key) => key.indicapresenca !== null),
          aaletivo: this.ano,
          cdinstruc: this.cdinstruc,
          identificadoraulaAluno: this.identificadoraulaAluno,
        };

        const { data } = await DiarioEscolarRepository.setFrequancia(
          formulario
        );
        //let aulaLancada = [];

        this.submitText = data.message;
        this.snackbar = true;
        this.loading = false;
        this.aulaLancadaFrequencia.push(...formulario.identificadoraula);
        this.frequenciasIniciais = [...this.frequenciasModificadas]

        this.$root.$router.push({
          name: this.redirect,
          params: {
            ano: this.ano,
            cdturma: this.cdturma,
            disciplina: this.disciplina,
            tipoDeEnsino: this.tipoDeEnsino,
            cdinstruc: this.cdinstruc,
            aulasParaLancarFrequencia: this.aulasLancandoFrequencia,
            frequenciaLancada: this.aulaLancadaFrequencia,
            turmaOuDisciplina: this.turmaOuDisciplina,
            AEEouACP: this.AEEouACP,
            pagina: this.pagina === "undefined" ? 1 : this.pagina,
          },
        });

      } catch (error) {
        if (
          error.response &&
          error.response.data.status == "ERROR_BUSINESS_RULE"
        ) {
          this.msgArrayError = error.response.data.errorMessage;
        }
      } finally {
        this.loading = false;
      }
     this.frequenciasIniciais = [...this.frequenciasModificadas]
      //  this.frequenciasIniciais = this.form.alunos.map(f => f.indicapresenca)
      // this.frequenciasIniciais = [...this.frequenciasModificadas]
    },
    marcarTodos() {
      this.form.alunos = this.form.alunos.map((key) => {
        if (
          !(
            this.verificarDataEnturmacao(key.dataEnturmacao) ||
            this.verificarSituacao(key.situacao_fim, key.dataSituacaoFim) ||
            key.dispensadoDisciplina
          )
        ) {
          key.indicapresenca = "P";
          if (
            this.indicamodelodeaula === "R" ||
            this.indicamodelodeaula === "H"
          ) {
            key.indicaalunoremoto = key.indicapresenca === "P" ? "S" : "N";
          }
        }
        return key;
      });

    },

  desmarcarTodos() {
      this.form.alunos = this.form.alunos.map((key) => {
        if (
          !(
            this.verificarDataEnturmacao(key.dataEnturmacao) ||
            this.verificarSituacao(key.situacao_fim, key.dataSituacaoFim) ||
            key.dispensadoDisciplina
          )
        ) {
          key.indicapresenca = "A";
          if (
            this.indicamodelodeaula === "R" ||
            this.indicamodelodeaula === "H"
          ) {
            key.indicaalunoremoto = key.indicapresenca === "A" ? "S" : "N";
          }
        }
        return key;
      });

    },

    marcarTodosRemoto() {
      this.form.alunos = this.form.alunos.map((key) => {
        if (
          !(
            this.verificarDataEnturmacao(key.dataEnturmacao) ||
            this.verificarSituacao(key.situacao_fim, key.dataSituacaoFim) ||
            key.dispensadoDisciplina
          )
        ) {
          if (this.indicamodelodeaula === "R") {
            key.indicaalunoremoto = "S";
          } else {
            key.indicaalunoremoto = "N";
          }
        }
        return key;
      });
    },
    verificarSituacao(situacao, dataSituacao) {
      if (typeof situacao === "undefined" || situacao === null) {
        return false;
      }
      if (this.situacaoFim.indexOf(parseInt(situacao.cdsitalun)) >= 0) {
        if (this.dataaula < dataSituacao) {
          return false;
        }
        return true;
      }
      return false;
    },
    verificarDataEnturmacao(dataEnturmacao) {
      return dataEnturmacao > this.dataaula;
    },
    desabilitarBotao() {
      const camposVazios = this.form.alunos.reduce((total, valor) => {
        if (valor.indicapresenca !== null) {
          return false;
        }
        return total;
      }, true);
      return this.form.alunos.length === 0 || camposVazios;
    },
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.atalhoParaVoltar)
  },
  computed: {
    frequenciasModificadas() {
      return this.form.alunos.map(f => f.indicapresenca)
    },
    usuarioMudouFrequencia() {
      return !this.frequenciasModificadas.every((element, index) => element === this.frequenciasIniciais[index])
    }
  }
};
</script>

<style>
/* @media screen and (min-width: 500px)
        {

             .quebra-linha-responsiva br
             {
                display: none;
             }
        } */
</style>
